
export const text = `

How does Nidhogg relate to any of this? :) :) :)

If you know, would you put it on the wiki?  The marketplace of ideas. 

What will win?
`